<template>
  <div>
    <div v-loading="nalaganjeSoglasij" v-if="niNosilecNarocnine !== true">
      <div>
        <div style="padding-bottom: 37px">
          <div style="padding-top: 40px">
            <div v-for="soglasje in gdprSeznam" style="padding-bottom: 40px">
              <div>
                <ul>
                  <li>
                    <span class="open-sans-20pt">
                      {{ soglasje.naziv }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="odmik-vsebine-od-naslova">
                <p class="navadno-besedilo">
                  {{ soglasje.opis }}
                </p>
              </div>
              <div class="odmik-soglasja">
                <div class="navadno-besedilo">
                  {{ soglasje.soglasje }}
                </div>
                <div class="postavitev-soglasja" style="padding-top: 20px">
                  <el-radio-group v-model="soglasje.soglasam">
                    <el-radio :label="true">
                      DA
                    </el-radio>
                    <el-radio :label="false">
                      NE
                    </el-radio>
                    <div class="postavitev-soglasje-se-ni-podano">
                      <span v-if="soglasje.soglasam === null">
                          <el-radio :label="null">
                              Soglasje še ni podano
                          </el-radio>
                      </span>
                    </div>
                  </el-radio-group>
                </div>
              </div>
              <div style="clear: both"/>
            </div>
          </div>
          <div class="postavitev-gumbov">
            <div>
              <p class="navadno-besedilo">
                Seznanjen sem, da lahko vsako podano soglasje kadarkoli prekličem na enak način, kot sem ga
                podal. Preklic lahko podam tudi pisno na naslov T-2 d.o.o., Verovškova ulica 64a, Ljubljana.
              </p>
            </div>
            <div class="postavitev-gumba-shrani">
              <el-button class="gumb-potrdi shranite-spremembe" @click="ShraniSoglasja">
                SHRANITE SPREMEMBE
              </el-button>
            </div>
          </div>
        </div>
        <hr class="hr-stil"/>
        <div style="padding-top: 37px;">
          <div style="padding-bottom: 20px">
            <p class="open-sans-20pt">
              Prilagodite si način komuniciranja z nami
            </p>
          </div>
          <div>
            <p class="open-sans-18pt">
              Obvestila in ponudba
            </p>
            <p class="navadno-besedilo">
              Obveščali vas bomo le s ponudbo in informacijami, ki bodo za vas najbolj primerne in koristne. Če ne
              želite prejemati obvestil, prosimo izberite želene prepovedi:
            </p>
          </div>
          <div>
            <div style="padding-bottom: 20px">
              <div class="container-prepovedi wrap" >
                <div v-for="prepoved in prepovedi" class="box">
                  <el-checkbox v-model="prepoved.vklopljeno" @change="PotrditvenoOknoPrepovedi(prepoved)"/>
                  <span class="navadno-besedilo stil-obvescanj">
                    {{prepoved.naziv}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p class="open-sans-18pt mt-3">
              Obveščanje o spremembi pogodbenih pogojev
            </p>
            <p class="navadno-besedilo">
              Prosimo, izberite komunikacijski kanal, preko katerega želite prejemati obvestila o spremembah pogodbenih pogojev:
            </p>
          </div>
          <div>
            <div style="padding-bottom: 20px">
              <div class="container-prepovedi wrap" >
                <el-radio-group
                  class="mobile-list"
                  v-model="idTipObvescanjaOSplosnihPogojihVal"
                  @change="PotrditvenoOknoPrepovedi(idTipObvescanjaOSplosnihPogojihVal, true)">
                  <el-radio
                    :label="nacinObvescanja.idStrankaObvescanjeTip"
                    :key="nacinObvescanja.idStrankaObvescanjeTip"
                    v-for="nacinObvescanja in naciniObvescanjaSplosniPogoji"
                    class="odmik-radio">
                    {{nacinObvescanja.naziv}}
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Checkbox, Button, Option, Select, Radio, CheckboxGroup, MessageBox} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'

export default {
  name: 'Soglasja',
  emits: ['osveziPodatkeStranke'],
  data () {
    return {
      clientAgent: null,
      seznamSoglasij: [],
      SeznamSpremenjenihSoglasij: [],
      nalaganjeSoglasij: false,
      gdprSeznam: [],
      niNosilecNarocnine: false,
      soglasja: [],
      nalaganjePrepovedi: false,
      prepovedi: [],
      saveChanges: [],
      prepovedanOsebniSvetovalec: 6,
      vsebina: [],
      responseShrani: null,
      prenosniParam: null,
      response: null,
      naciniObvescanjaSplosniPogoji: [],
      idTipObvescanjaOSplosnihPogojihVal: 1
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.PridobivanjeSoglasij()
    this.PridobivanjePrepovedi()
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Radio.name]: Radio,
    [CheckboxGroup.name]: CheckboxGroup
  },
  props: {
    izbranaStanka: '',
    idTipObvescanjaOSplosnihPogojih: {
      type: Number,
      default: 1
    }
  },
  watch: {
    izbranaStanka () {
      if (this.izbranaStanka !== '') {
        this.idTipObvescanjaOSplosnihPogojihVal = this.idTipObvescanjaOSplosnihPogojih
        this.PridobivanjeSoglasij()
        this.PridobivanjePrepovedi()
      }
    }
  },
  methods: {
    PotrditvenoOknoPrepovedi (nacin, nacinObvescanjaOPogojih = false) {
      this.prenosniParam = nacin
      if (!nacinObvescanjaOPogojih) {
        if (!nacin.vklopljeno) {
          this.message = 'Ali ste prepričani, da želite umakniti prepoved  '
        } else {
          this.message = 'Ali ste prepričani, da želite izbrati prepoved '
        }
      }
      let messageBOxText = nacinObvescanjaOPogojih
        ? 'Ali ste prepričani, da želite spremeniti način obveščanja o spremembi splošnih pogojev'
        : this.message + nacin.naziv
      MessageBox.confirm(
        messageBOxText + '?',
        '', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        if (nacinObvescanjaOPogojih) {
          this.ShraniNacinObvescanja(this.prenosniParam)
        } else {
          this.ShraniPrepovedi(this.prenosniParam)
        }
      }).catch((err) => {
        err = null
        this.PridobivanjePrepovedi()
      })
    },
    async PridobivanjePrepovedi () {
      try {
        this.nalaganjePrepovedi = true
        if (this.izbranaStanka !== undefined) {
          this.response = await this.clientAgent.makeRequest(
            'stranka/obvescanje/info',
            {
              idStranka: this.izbranaStanka
            },
            'GET'
          )
          this.SetPridobivanjePrepovedi(this.response)
        }
      } catch (e) {
        this.ErrPridobivanjePrepovedi({message: 'Prišlo je do napake.'})
        this.nalaganjePrepovedi = false
      }
    },
    SetPridobivanjePrepovedi (podatki) {
      this.prepovedi = []
      this.naciniObvescanjaSplosniPogoji = []
      this.prenosniParam = null
      this.idTipObvescanjaOSplosnihPogojihVal = this.idTipObvescanjaOSplosnihPogojih
      for (let i = 0; i < podatki.data.length; i++) {
        if (podatki.data[i].idStrankaObvescanjeTip !== this.prepovedanOsebniSvetovalec) {
          this.prepovedi.push(podatki.data[i])
          if ([1, 2, 3].includes(podatki.data[i].idStrankaObvescanjeTip)) {
            this.naciniObvescanjaSplosniPogoji.push(podatki.data[i])
          }
        }
      }
      this.nalaganjePrepovedi = false
    },
    ErrPridobivanjePrepovedi (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalaganjePrepovedi = false
    },
    async ShraniPrepovedi (prepoved) {
      try {
        this.vsebina = []
        this.vsebina.push({
          idStrankaObvescanjeTip: prepoved.idStrankaObvescanjeTip,
          vklopljeno: prepoved.vklopljeno
        })
        this.responseShrani = await this.clientAgent.makeRequest(
          '/stranka/obvescanje/shrani',
          {
            idStranka: this.izbranaStanka,
            data: JSON.stringify(this.vsebina)
          }
        )
        this.SetShraniPrepovedi()
      } catch (e) {
        this.ErrShraniPrepovedi(this.responseShrani)
      }
    },
    async ShraniNacinObvescanja (nacinObvescanja) {
      try {
        this.vsebina = {
          idStranka: this.izbranaStanka,
          idTipObvescanja: nacinObvescanja
        }
        this.responseShrani = await this.clientAgent.makeRequest(
          '/stranka/soglasja/shraniNacinObvescanjaOSpremembahPogojev',
          this.vsebina
        )
        this.SetShraniNacinObvescanja()
      } catch (e) {
        this.ErrShraniPrepovedi(this.responseShrani)
      }
    },
    SetShraniNacinObvescanja () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Način obveščanja uspešno posodobljen.'
      this.ShowSuccessMessage(paramObvestilo)
      this.$emit('osveziPodatkeStranke')
    },
    SetShraniPrepovedi () {
      this.prepovedi = []
      let paramObvestilo = {}
      paramObvestilo.message = 'Prepovedi obveščanja uspešno posodobljene.'
      this.ShowSuccessMessage(paramObvestilo)
      this.prepovedi = []
      this.PridobivanjePrepovedi()
    },
    ErrShraniPrepovedi (podatki) {
      this.ShowWarningMessage(podatki)
      this.prepovedi = []
      this.idTipObvescanjaOSplosnihPogojihVal = this.idTipObvescanjaOSplosnihPogojih
      this.PridobivanjePrepovedi()
      this.nalaganjePrepovedi = false
    },
    PridobivanjeSoglasij () {
      this.nalaganjeSoglasij = true
      this.soglasja = []
      if (this.izbranaStanka !== undefined) {
        let param = ['idStranka=' + this.izbranaStanka]
        this.clientAgent.postWsRequest(
          this,
          '/stranka/soglasja/pridobiSoglasja?',
          param,
          null,
          'SetPridobivanjeSoglasij',
          'ErrPridobivanjeSoglasij')
      } else {
        this.nalaganjeSoglasij = false
      }
    },
    SetPridobivanjeSoglasij (podatki) {
      this.gdprSeznam = []
      for (let skupekSoglasij in podatki.data) {
        this.soglasja.push(podatki.data[skupekSoglasij])
      }
      for (let i = 0; i < this.soglasja.length; i++) {
        if (this.soglasja[i].group === 'gdpr') {
          this.gdprSeznam.push(this.soglasja[i])
        }
      }
      this.nalaganjeSoglasij = false
      this.niNosilecNarocnine = false
    },
    ErrPridobivanjeSoglasij (podatki) {
      this.ShowWarningMessage(podatki)
      this.niNosilecNarocnine = true
      this.nalaganjeSoglasij = false
    },
    ShraniSoglasja () {
      let param = ['idStranka=' + this.izbranaStanka]
      for (let i = 0; i < this.gdprSeznam.length; i++) {
        param.push('soglasja' + '[' + this.gdprSeznam[i].idTip + ']=' + this.gdprSeznam[i].soglasam)
      }
      this.clientAgent.postWsRequest(
        this,
        '/stranka/soglasja/shraniSoglasja?',
        param,
        null,
        'SetShraniSoglasja',
        'ErrtShraniSoglasja')
    },
    SetShraniSoglasja () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Soglasja uspešno posodobljena.'
      this.ShowSuccessMessage(paramObvestilo)
      this.PridobivanjeSoglasij()
    },
    ErrtShraniSoglasja () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Ničesar niste spremenili.'
      this.ShowWarningMessage(paramObvestilo)
      this.PridobivanjeSoglasij()
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/OsebniPodatkiInSoglasja/osebniPodatkiInSoglasja.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/OsebniPodatkiInSoglasja/Soglasja.vue